// Generated by scripts/generate-research-covers.py; do not edit by hand.
export const researchPdfCovers: Record<string, string> = {
  "Adcrayonix_Business_Overview.pdf": "/research-covers/Adcrayonix_Business_Overview.webp",
  "Istatec_Document_Unlocking_Pipeline.pdf": "/research-covers/Istatec_Document_Unlocking_Pipeline.webp",
  "iStatec_AI_Customer_Support_Chatbot_RAG_Whitepaper.pdf": "/research-covers/iStatec_AI_Customer_Support_Chatbot_RAG_Whitepaper.webp",
  "iStatec_GenAI_for_Contact_Center_Whitepaper_v2.pdf": "/research-covers/iStatec_GenAI_for_Contact_Center_Whitepaper_v2.webp",
  "iStatec_IstaConvert_Website_Overview.pdf": "/research-covers/iStatec_IstaConvert_Website_Overview.webp",
  "iStatec_Salesforce_Case_Automation_Overview.pdf": "/research-covers/iStatec_Salesforce_Case_Automation_Overview.webp"
};
